import React, { useEffect } from "react";
import useEffectAsync from "../../../../utilities/hooks/useEffectAsync";
import { connect, useDispatch } from "react-redux";
import { goToPage, setFlowType, setPersonalInfo, reportDWH } from "../saleJetBlockSlice";
import Lottie from "react-lottie";
import loginSuccessAnimation from "../../../../animations/loginSuccess.json";
import { reAuthenticateThunk } from "../../../../utilities/authentication/authenticationSlice";
import authenticationProvider from "../../../../utilities/authentication/authenticationProvider";
import {prepareSaleAsync,checkUserAsync,createOtpForNewCustomerAsync} from "../saleBlockAsyncThunk";
import { gtag4 } from '../../../../utilities/analytics/tracking';
import Config from '../../../../Config';
import ThemedLottie from '../../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../../utilities/theme/ThemeColorEnum';
import {isOrgEmployeeLogin} from 'app/Components/Block/OTPLoginBlock/Assets/variables';
const LoginPage = (props) => {

  useEffect(() => {
    props.reportDWH({ actionType: 'Login Page', status: 'Ongoing', messageText: 'Login Page Displayed' });
    if (props.saleType == 'cellular'){
      gtag4({event: 'cellular_Step2_LoginPage',step: '2',action: 'LoginPage',funnel_name: 'Choose_Package'});
    }
    else{
      gtag4({event: `${props.saleType}_Step4_LoginPage`,step: '4',action: 'LoginPage',funnel_name: 'Sivim_Exists'});
    }
      if(isOrgEmployeeLogin(props._authentication)){
        localStorage.setItem("isOrgEmployeeLogin", "true");
      }else{
        localStorage.setItem("isOrgEmployeeLogin", "false");
      }

  }, []);


  const handleOrgEmployeeLogin = async () => {
    var storage = window.localStorage || window.sessionStorage;
    var urlVariables;
    try {
      urlVariables = JSON.parse(storage.getItem("urlVariables"));
    } catch (e) {}
    await props.setPersonalInfo({
      ...props.personalInfo,
      isCustomerExists: false,
      identity: urlVariables?.identity,
      subscriberNo: urlVariables?.contactNumber,
    });
    await props.prepareSaleAsync();
  }


  useEffectAsync(async () => {
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
    eventer(
      messageEvent,
      async function (e) {
        if (e.data.eventType != "returnFromLogin") { return; }
        console.log("parent received message!:  ", e.data);

        switch (e.data.status) {
          case "loginSuccess":
            props.goToPage("loginSuccessPage");
            break;
          case "newCustomer":
          

            var storage = window.localStorage || window.sessionStorage;
            var urlVariables;
            try {
              urlVariables = JSON.parse(storage.getItem("urlVariables"));
            } catch (e) {}

            if (urlVariables?.newcustomer == "1") {
              props.createOtpForNewCustomerAsync(urlVariables);
              props.setFlowType("newCustomer");
              storage.setItem("previousPage", "newcustomer");
              storage.setItem("urlVariables", "");
            }
            break;
          case "orgEmployeeFamily": {
             handleOrgEmployeeLogin(urlVariables);
            break;
          }
              default:
            break;
        }
      },
      false,
    );
  }, []);

  const returnUrl = encodeURIComponent(
    window.location.pathname + window.location.hash.toLowerCase(),
  );
  const loginUrl = authenticationProvider.getLoginUrl(returnUrl, "", "LITE");

  let title = "כמה פרטים כדי שנוכל להתקדם";
  let subTitle = "";

  let currentPageHeadline = (
    <div className="page-headline-wrapper">
      <h1 className="sale-title"></h1>
      <h1 className="sale-title-big">{title}</h1>
      <h2 className="sale-title-small">{subTitle}</h2>
    </div>
  );

  let currentPageView = null;

  if (props._authentication.loginData.isFullAuthenticated) {
    currentPageView = (
      <div className="login-success-wrapper">
        {/* <Lottie options={{animationData: loginSuccessAnimation,loop: false,resizeMode: "cover"}} height={250} /> */}
        <ThemedLottie animationData={loginSuccessAnimation} color={ThemeColorEnum.PRIMARY} height={250} loop={false} resizeMode="cover" />
      </div>
    );
  } else {
    currentPageView = (
      <div className="login-iframe-wrapper">
        <iframe src={loginUrl} frameBorder="0" className="login-iframe" title=""></iframe>
        {
          Config.loginPageLegalText &&
          <div className='login-bottom-text' dangerouslySetInnerHTML={{ __html: Config.loginPageLegalText }}></div>
        }
      </div>
    );
  }

  return (
    <div className="slideAnimation">
      {currentPageHeadline}
      <div className="sale-page-content">
        <form noValidate id="sale" onSubmit={handleSubmit}>
          {currentPageView}
        </form>
      </div>
    </div>
  );

  function handleSubmit(event) {
    event.preventDefault();
  }
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    offerName: state.saleJetBlock.offerName,
    personalInfo: state.saleJetBlock.personalInfo,
    routers: state.saleJetBlock.saleCatalog?.routers,
    firstTechnicianTimeDisplay:
    state.saleJetBlock.technician.firstTechnicianTimeDisplay,

    //other states
    _authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  goToPage,
  setFlowType,
  setPersonalInfo,
  prepareSaleAsync,
  checkUserAsync,
  reAuthenticateThunk,
  createOtpForNewCustomerAsync,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
